export default __webpack_public_path__ + "static/media/showHide.44d6634a.svg";